<template>
  <f7-sheet class="high darker" :backdrop="true" :opened="show" @sheet:closed="$emit('closed')">
    <f7-toolbar>
      <div class="left">

      </div>
      <div class="right">
        <f7-link sheet-close>
          Sluiten
        </f7-link>
      </div>
    </f7-toolbar>

    <f7-block-title>
      {{ activity.name }} Notities
    </f7-block-title>
    <f7-block-header>
      Sla notities op over je reps, vermoeidheid, techniek, etc. Deze worden automatisch opgeslagen voor toekomstige
      trainingen.
    </f7-block-header>
    <f7-text-editor
        ref="text-editor"
        :value="notes"
        @texteditor:change="update_activity"
        placeholder="Jouw notities..."
        mode="popover"
        :buttons="['bold', 'italic', 'underline', 'strikeThrough']"
        style="--f7-text-editor-height: 150px"
    />
    <f7-block-footer style="text-align: right;">
      <strong>{{ notes.length }}</strong>/4096
    </f7-block-footer>

  </f7-sheet>
</template>

<script>

import ThrottlesRequests from "../../mixins/ThrottlesRequests.vue";
import { sanitiseNotesHtml } from "../../js/sanitise";

export default {
  components: {},

  props: [
    'show',
    'activity',
    'training_session',
  ],

  mixins: [
    ThrottlesRequests
  ],

  data: function () {
    return {
      notes: '',
      updated: 0,
    };
  },

  computed: {
    activityNotes() {
      return this.activity.notes;
    },
    user_id() {
      return this.$store.state.current_user.data.id;
    },
  },

  created() {
    //
  },

  /**
   * SANITISED ON THE WAY IN. `notes` is bound to `<f7-text-editor :value>`, and
   * framework7 implements that binding as `self.$contentEl.html(newValue)`
   * (framework7/components/text-editor/text-editor-class.js:126-134) — raw
   * `innerHTML` into a live contenteditable, i.e. the same execution semantics
   * as `v-html`. So an API-supplied value assigned here runs whatever it
   * carries; the CSP is stock Cordova boilerplate (`default-src *` with
   * `unsafe-inline`) and stops nothing.
   *
   * Found by `tests/js/richtext-sink-coverage.test.js`, the gate added for the
   * phase-43 adversarial review's finding 1, which named this file on its first
   * run. Realistically this is self-XSS — the sheet only shows the current
   * member their own activity, and `update_activity()` already strips every tag
   * on the way out — so it is defence in depth rather than the super-admin
   * exposure the review found in the news composer. It is closed rather than
   * excepted so the gate can stay unconditional.
   *
   * `sanitiseNotesHtml` is the `user_notes` profile: `<br>` and nothing else,
   * the narrowest of the three. It also returns `''` for a non-string, which
   * fixes a second, unrelated live defect — an activity that has never been
   * annotated carries `null` here, and `{{ notes.length }}` in the footer threw
   * "Cannot read properties of null" on every render of it.
   */
  mounted() {
    this.notes = sanitiseNotesHtml(this.activity.notes);
  },

  methods: {
    update_activity(newNote) {
      this.updated++;
      // Disable it on the first page-load
      if (this.updated === 1) {
        return null;
      }

      this.notes = this.cleanString(newNote);
      this.dispatchThrottled('activities/update_only', {
        user_id: this.user_id,
        activity_id: this.activity.id,
        training_session_id: this.training_session.id,
        notes: this.notes,
      }, 1500).then(response => {

        // Dan updaten we die single waarde om de reactivity niet te breken
        this.$store.commit('activities/update_model', {
          id: this.activity.id,
          property: 'notes',
          value: this.notes
        });

        this.$store.dispatch('notifications/addSuccessNotification', {
          message: 'Notitie opgeslagen'
        });
      });
    },
    cleanString(str) {
      if ((str===null) || (str===''))
        return false;
      else
        str = str.toString();

      // Regular expression to identify HTML tags in
      // the input string. Replacing the identified
      // HTML tag with a null string.
      return str.replace( /(<([^>]+)>)/ig, '');
    }
  },

  watch: {
    activityNotes(value) {
      // this.notes = value;
    },
  }
};
</script>
